import {Component, Input} from '@angular/core';
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {RouterLink} from "@angular/router";
import {JsonPipe} from "@angular/common";

@Component({
  selector: 'white-label-default-footer',
  standalone: true,
    imports: [
        RouterLink,
        JsonPipe
    ],
  providers: [
  ],
  templateUrl: './default-footer.component.html'
})
export class DefaultFooterComponent {
    whiteLabel: any;
    constructor(private mainStoreService: MainStoreService) {
        this.whiteLabel = this.mainStoreService.whiteLabel;
    }
}


